import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=1ccc43e4&scoped=true&"
import script from "./Product.js?vue&type=script&lang=js&"
export * from "./Product.js?vue&type=script&lang=js&"
import style0 from "./Product.scss?vue&type=style&index=0&id=1ccc43e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc43e4",
  null
  
)

export default component.exports